import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SvgIconFacade } from '../../store/state/svg-icon';
import { AutoUnsubscribe } from '../../common/decorators';
import { IconNames } from '../../common/constants';
import { IconWidthType } from './svg-icon.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'ui-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class SvgIconComponent {
  @Input() set name(iconName: IconNames) {
    this.icon = iconName;

    this.loadSvg();
  }

  @Input() width?: IconWidthType | number = 24;
  @Input() height?: IconWidthType | number = 'auto';

  icon: IconNames | string;
  sanitizedSvgContent$: Observable<SafeHtml>;

  constructor(private svgIconFacade: SvgIconFacade) {}

  get testId(): string {
    return this.icon ? `icon-${this.icon}` : null;
  }

  transformSize(input: IconWidthType | number): string {
    if (typeof input === 'string') {
      return isNaN(parseInt(input, 10)) ? input : `${input}px`;
    }

    return `${input}px`;
  }

  private loadSvg(): void {
    if (!this.icon) {
      return;
    }

    const svgPath = `assets/core/icons/${this.icon}.svg`;

    if (!this.svgIconFacade.getSvgIconMap().has(svgPath)) {
      this.svgIconFacade.loadSvgIcon(svgPath);
    }

    this.sanitizedSvgContent$ = this.svgIconFacade.getSvgIconMap().get(svgPath);
  }
}
